import { Base } from "../../../handlers";
import { validators } from "./validators/validators";
export class InventoryPackages extends Base {
    constructor(sdk) {
        super(sdk, "products.inventoryPackages");
        this.validators = validators(sdk);
    }
}
//# sourceMappingURL=index.js.map